import React, { useEffect, useRef } from "react";

const drawOptions = [
  { id: "draw", label: "Pencil", icon: "/icons/Pencil.png" },
  { id: "eraser", label: "Eraser", icon: "/icons/Eraser.png" },
];

const PopoutDrawMenu = ({
  visible,
  anchor = { x: 0, y: 0 },
  activeTool,
  color,
  onSelectTool,
  onColorChange,
  onClose,
}) => {
  const menuRef = useRef(null);

  useEffect(() => {
    if (!visible) return undefined;

    const handleClickOutside = (event) => {
      if (event.target.closest("[data-draw-menu-trigger]")) return;
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [visible, onClose]);

  if (!visible) return null;

  return (
    <div
      ref={menuRef}
      role="dialog"
      aria-label="Drawing tools"
      style={{
        position: "fixed",
        top: anchor.y,
        left: anchor.x,
        zIndex: 1000,
        padding: 8,
        color: "#ddd",
        backgroundColor: "#222",
        border: "1px solid #444",
        borderRadius: 4,
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.5)",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {drawOptions.map((option) => (
          <button
            key={option.id}
            className={`toolbar-btn ${activeTool === option.id ? "active" : ""}`}
            type="button"
            aria-label={option.label}
            aria-pressed={activeTool === option.id}
            title={option.label}
            onClick={() => {
              onSelectTool(option.id);
              onClose();
            }}
            style={{ padding: 8 }}
          >
            <img
              src={option.icon}
              alt=""
              className="toolbar-icon"
            />
          </button>
        ))}
        <label
          className="toolbar-btn"
          title="Drawing color"
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 8,
            cursor: "pointer",
            boxSizing: "border-box",
          }}
        >
          <span
            aria-hidden="true"
            data-testid="drawing-color-icon"
            style={{
              width: 28,
              height: 28,
              backgroundColor: color,
              maskImage: 'url("/icons/Colour.png")',
              maskPosition: "center",
              maskRepeat: "no-repeat",
              maskSize: "contain",
              WebkitMaskImage: 'url("/icons/Colour.png")',
              WebkitMaskPosition: "center",
              WebkitMaskRepeat: "no-repeat",
              WebkitMaskSize: "contain",
              pointerEvents: "none",
            }}
          />
          <input
            type="color"
            aria-label="Choose drawing color"
            value={color}
            onChange={(event) => onColorChange(event.target.value)}
            style={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              padding: 0,
              opacity: 0,
              cursor: "pointer",
            }}
          />
        </label>
      </div>
    </div>
  );
};

export default PopoutDrawMenu;
